module.exports = __webpack_public_path__ + "static/pensjonat-wiosna-16f1c8acf74ef02f48b13b12acb7f4e5.jpg";